// src/routes/ReturnBatchRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

// Return Batch Components
import CreateReturnBatchPage from '../pages/returnBatch/CreateReturnBatchPage';
import ReturnBatchListPage from '../pages/returnBatch/ReturnBatchListPage';
import ReturnBatchDetailsPage from '../pages/returnBatch/ReturnBatchDetailsPage';

const ReturnBatchRoutes = () => {
  return (
    <Routes>
      {/* Process Returns (Scanning Interface) */}
      <Route 
        path="/process" 
        element={
          <PermissionRoute requiredPermission="process_returns">
            <CreateReturnBatchPage />
          </PermissionRoute>
        } 
      />
      
      {/* Return Batch List & Management */}
      <Route 
        path="/" 
        element={
          <PermissionRoute requiredPermission="view_return_batches">
            <ReturnBatchListPage />
          </PermissionRoute>
        } 
      />
      
      {/* Return Batch Detail Page */}
      <Route 
        path="/:batchId" 
        element={
          <PermissionRoute requiredPermission="view_return_batches">
            <ReturnBatchDetailsPage />
          </PermissionRoute>
        } 
      />
    </Routes>
  );
};

export default ReturnBatchRoutes;